import html from './mission.frag.html';

export async function initMissionGraph (containerId) {
  const $container = document.querySelector(containerId);
  $container.insertAdjacentHTML('beforeend', html);

  return true;
}
